import request from "./config";

export default class OrderServicesService {
  static create(data) {
    return request({
      url: "/order-services",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/order-services/${id}`,
      method: "patch",
      data,
    });
  }
  static changeStatus(id,data) {
    return request({
      url: `/order-services/change-status/${id}`,
      method: "patch",
      data,
    });
  }
  
  static delete(id) {
    return request({
      url: `/order-services/${id}`,
      method: "delete",
    });
  }
  static  find(params) {
    return request({
      url: `/order-services`,
      method: "get",
      params:params
    });
  }
}
